import { signal, computed, effect, createRouter } from "zyra";
import { pages, href, type Page } from "../content";
export function createSiteState() {
  const menu = signal(false);
  const searching = signal(false);
  const router = createRouter({
    title: (path) => titleForPath(path),
  });
  // Hash navigation keeps the current page instance and its live demo state.
  const pathname = signal(location.pathname);
  effect(() => {
    pathname.value = router.path.value.split(/[?#]/)[0];
  });
  const current = computed(() => pages.find((p) => href(p) === pathname.value));
  document.title = titleForPath(router.path.value);
  function go(page: Page) {
    menu.value = false;
    searching.value = false;
    router.navigate(href(page));
  }

  return { menu, searching, router, current, pathname, go };
}
function titleForPath(path: string): string {
  const pathname = path.split(/[?#]/)[0];
  if (pathname === "/") return "Zyra — Less friction. More feeling.";
  return (
    (pages.find((page) => href(page) === pathname)?.title ?? "Page not found") +
    " — Zyra Docs"
  );
}
export type SiteState = ReturnType<typeof createSiteState>;
